import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";
import moment from "moment";

export async function getProductsPrices({ commit, state }) {
    commit("setLoading", true);

    const branchoffice_id = localStorage.selected_branchoffice;
    const params = {
        ...state.params,
        branchoffice_id
    };

    await $http
        .get("/api/report-product-pricing", {
            params
        })
        .then(response => {
            commit("setLoading", false);
            commit("setProductsPrices", response.data.data);
        })
        .catch(error => {
            console.error(error);
            commit("setLoading", false);
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function uploadFilePrices({ commit, state, dispatch }) {
    commit("setLoading", true);

    const formData = new FormData();
    formData.append("file", state.paramsFile.file);

    await $http
        .post("/api/actualizar-precio-lite", formData)
        .then(response => {
            commit("setLoading", false);
            commit("resetParamsFile", true);
            dispatch("getProductsPrices");
            Notification.success({
                title: "Éxito!",
                message: "Precios Actualizados.",
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            console.error(error);
            commit("setLoading", false);
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function putRevertPrices({ commit, dispatch }) {
    commit("setLoading", true);

    const branchoffice_id = localStorage.selected_branchoffice;
    const body = {
        branchoffice_id
    };

    await $http
        .put("/api/revert-product-pricing", body)
        .then(response => {
            commit("setLoading", false);
            dispatch("getProductsPrices");
        })
        .catch(error => {
            commit("setLoading", false);
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/product-pricing/actions.js